/**
 * @param listType
 * @param urgent
 * @param isContactPrefTypePhone
 * @param isContactPrefTypeSms
 * @param isContactPrefTypeEmail
 */
export function getContactPreferencesText(listType, urgent, isContactPrefTypePhone = null, isContactPrefTypeSms = null, isContactPrefTypeEmail = null) {
    const EMAIL = 'email';
    const PHONE = 'phone';
    const SMS = 'sms';
    let contactPreference = [
        isContactPrefTypePhone ? PHONE : null,
        isContactPrefTypeSms ? SMS : null,
        isContactPrefTypeEmail ? EMAIL : null,
    ];
    let boldPreferences =  {
        'bold': `<span class="text-medium text-contact">`,
        'endbold': `</span>`
    }
    let boldAndUrgentPreferences =  {
        'bold': `<span class="text-medium text-contact">`,
        'endbold': `</span>`,
        'boldAndUrgent': `<span class="bold text-urgent">`,
        'endBoldAndUrgent': `</span>`
    }

    //remove falsely
    contactPreference = contactPreference.filter(Boolean);
    if (contactPreference.length > 0) {
        if (listType === 'lead-list'){
            if (contactPreference.includes(PHONE) && contactPreference.includes(SMS) && contactPreference.includes(EMAIL)) {
                return urgent
                    ? _t("seller_dashboard:contact-preferences.lead-list.contact-urgently-phone-sms-or-email", {...boldAndUrgentPreferences, "interpolation": {escapeValue: false}})
                    : _t("seller_dashboard:contact-preferences.lead-list.contact-phone-sms-or-email", {...boldPreferences, "interpolation": {escapeValue: false}});
            } else if (contactPreference.includes(PHONE) && contactPreference.includes(SMS)) {
                return urgent
                    ? _t("seller_dashboard:contact-preferences.lead-list.contact-urgently-phone-or-sms", { ...boldAndUrgentPreferences, "interpolation": {escapeValue: false}})
                    : _t("seller_dashboard:contact-preferences.lead-list.contact-phone-or-sms", {...boldPreferences, "interpolation": {escapeValue: false}});
            } else if (contactPreference.includes(PHONE) && contactPreference.includes(EMAIL)) {
                return urgent
                    ? _t("seller_dashboard:contact-preferences.lead-list.contact-urgently-phone-or-email", {...boldAndUrgentPreferences, "interpolation": {escapeValue: false}})
                    : _t("seller_dashboard:contact-preferences.lead-list.contact-phone-or-email", {...boldPreferences, "interpolation": {escapeValue: false}});
            } else if (contactPreference.includes(SMS) && contactPreference.includes(EMAIL)) {
                return urgent
                    ? _t("seller_dashboard:contact-preferences.lead-list.contact-urgently-sms-or-email", {...boldAndUrgentPreferences, "interpolation": {escapeValue: false}})
                    : _t("seller_dashboard:contact-preferences.lead-list.contact-sms-or-email", {...boldPreferences, "interpolation": {escapeValue: false}});
            } else if (contactPreference.includes(PHONE)) {
                return urgent
                    ? _t("seller_dashboard:contact-preferences.lead-list.contact-urgently-phone-only", {...boldAndUrgentPreferences, "interpolation": {escapeValue: false}})
                    : _t("seller_dashboard:contact-preferences.lead-list.contact-phone-only", { ...boldPreferences, "interpolation": {escapeValue: false}});
            } else if (contactPreference.includes(SMS)) {
                return urgent
                    ? _t("seller_dashboard:contact-preferences.lead-list.contact-urgently-sms-only", {...boldAndUrgentPreferences, "interpolation": {escapeValue: false}})
                    : _t("seller_dashboard:contact-preferences.lead-list.contact-sms-only", {...boldPreferences, "interpolation": {escapeValue: false}});
            } else if (contactPreference.includes(EMAIL)) {
                return urgent
                    ? _t("seller_dashboard:contact-preferences.lead-list.contact-urgently-email-only", {...boldAndUrgentPreferences, "interpolation": {escapeValue: false}})
                    : _t("seller_dashboard:contact-preferences.lead-list.contact-email-only", {...boldPreferences, "interpolation": {escapeValue: false}});
            }
        }
        if (listType === 'lead-details'){
            if (contactPreference.indexOf('phone') !== -1 && contactPreference.indexOf('sms') !== -1 && contactPreference.indexOf('email') !== -1) {
                return urgent
                    ? _t("seller_dashboard:contact-preferences.lead-details.contact-urgently-phone-sms-or-email", {...boldAndUrgentPreferences, "interpolation": {escapeValue: false}})
                    : _t("seller_dashboard:contact-preferences.lead-details.contact-phone-sms-or-email", {...boldPreferences, "interpolation": {escapeValue: false}});
            } else if (contactPreference.indexOf('phone') !== -1 && contactPreference.indexOf('sms') !== -1) {
                return urgent
                    ? _t("seller_dashboard:contact-preferences.lead-details.contact-urgently-phone-or-sms", { ...boldAndUrgentPreferences, "interpolation": {escapeValue: false}})
                    : _t("seller_dashboard:contact-preferences.lead-details.contact-phone-or-sms", {...boldPreferences, "interpolation": {escapeValue: false}});
            } else if (contactPreference.indexOf('phone') !== -1 && contactPreference.indexOf('email') !== -1) {
                return urgent
                    ? _t("seller_dashboard:contact-preferences.lead-details.contact-urgently-phone-or-email", {...boldAndUrgentPreferences, "interpolation": {escapeValue: false}})
                    : _t("seller_dashboard:contact-preferences.lead-details.contact-phone-or-email", {...boldPreferences, "interpolation": {escapeValue: false}});
            } else if (contactPreference.indexOf('sms') !== -1 && contactPreference.indexOf('email') !== -1) {
                return urgent
                    ? _t("seller_dashboard:contact-preferences.lead-details.contact-urgently-sms-or-email", {...boldAndUrgentPreferences, "interpolation": {escapeValue: false}})
                    : _t("seller_dashboard:contact-preferences.lead-details.contact-sms-or-email", {...boldPreferences, "interpolation": {escapeValue: false}});
            } else if (contactPreference.indexOf('phone') !== -1) {
                return urgent
                    ? _t("seller_dashboard:contact-preferences.lead-details.contact-urgently-phone-only", {...boldAndUrgentPreferences, "interpolation": {escapeValue: false}})
                    : _t("seller_dashboard:contact-preferences.lead-details.contact-phone-only", { ...boldPreferences, "interpolation": {escapeValue: false}});
            } else if (contactPreference.indexOf('sms') !== -1) {
                return urgent
                    ? _t("seller_dashboard:contact-preferences.lead-details.contact-urgently-sms-only", {...boldAndUrgentPreferences, "interpolation": {escapeValue: false}})
                    : _t("seller_dashboard:contact-preferences.lead-details.contact-sms-only", {...boldPreferences, "interpolation": {escapeValue: false}});
            } else if (contactPreference.indexOf('email') !== -1) {
                return urgent
                    ? _t("seller_dashboard:contact-preferences.lead-details.contact-urgently-email-only", {...boldAndUrgentPreferences, "interpolation": {escapeValue: false}})
                    : _t("seller_dashboard:contact-preferences.lead-details.contact-email-only", {...boldPreferences, "interpolation": {escapeValue: false}});
            }
        }
    }
    return null;
}
